import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';

export const appRoutes: Routes = [
    { path: '', redirectTo: '/roadmaps', pathMatch: 'full' },
    {
        path: '',
        component: AppLayout,
        canActivate: [],
        children: [
            { path: 'roadmaps', loadChildren: () => import('./app/pages/roadmaps/roadmaps.routes') },
            { path: 'topics/:topicId/quiz', loadChildren: () => import('./app/pages/quiz/quiz.routes') },
        ]
    },
    // { path: 'landing', component: Landing },
    { path: 'notfound', component: Notfound },

    { path: '**', redirectTo: '/notfound' }
];
